export default __webpack_public_path__ + "static/media/bubble.b4d93d46.svg";